import axios from 'axios';
import {
  API_URL, AUDIT_ANSWERS,
  AUDIT_CHECKLIST, AUDIT_CHECKLIST_SUB, AUDIT_DOWNLOAD_TEMPLATE, AUDIT_IMPORT_CHECKLIST,
  AUDIT_DOWNLOAD_CHECKLIST_REPORT,
} from './ConstantService';

export const InternalAuditChecklistService = {
  getAll(params = {}) {
    return axios.get(AUDIT_CHECKLIST, { params });
  },
  createChecklist(data){
    return axios.post(AUDIT_CHECKLIST, data);
  },
  updateChecklist(id, data) {
    return axios.put(`${AUDIT_CHECKLIST}/${id}`, data)
  },
  deleteSubItem(data) {
    return axios.delete(AUDIT_CHECKLIST, {data})
  },

  getAnswersChecklist(params = {}){
    return axios.get(AUDIT_ANSWERS, { params });
  },
  saveChecklist(data) {
    return axios.put(AUDIT_ANSWERS, data);
  },
  downloadBlankChecklist(params = {}) {
    return axios.get(
      AUDIT_DOWNLOAD_TEMPLATE,
      {
        params,
        responseType: 'blob'
      }
    );
  },
  downloadInternalAuditChecklistReport(params = {}) {
    return axios.get(
      AUDIT_DOWNLOAD_CHECKLIST_REPORT,
      {
        params,
        responseType: 'blob'
      }
    );
  },
  submitImportAIC(formData) {
    return axios.post(
      AUDIT_IMPORT_CHECKLIST,
      formData
    );
  }
};
